import React from 'react';
import DataTable from '../../../../components/DataTable';
import qualification from '../../../../ExcelFiles/qualification.xlsx';

function SupportQualification() {

    let columns = ["name", ["level", "name"]]
    let headers = ["Name", "Qualification Level"]

    let addform = [
        { 'name': 'name', 'label': 'Name', 'type': 'short-text', 'required': true },
        { 'name': 'level', 'label': 'Qualification', 'type': 'creatable', 'required': true, "url": "qualification-level/" },
    ]

    return (
        <DataTable
            title="Qualification"
            header={headers}
            url="qualification/"
            column={columns}
            addform={addform}
            excelheader={headers}
            filePath={qualification}
            filename="Qualification.xlsx"
            excelurl="qualification-import/"
        />
    );
}

export default SupportQualification;